import React from "react";
import { cn } from "@/lib/utils";

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className = "" }) => {
  return (
    <div
      className={cn(
        "flex h-full w-full flex-col justify-center gap-3 rounded-2xl border border-border bg-card px-4 py-4 sm:px-6 sm:py-6 md:py-7 lg:py-8",
        className
      )}
    >
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  children,
  className = "",
}) => {
  return <div className={cn("space-y-3", className)}>{children}</div>;
};

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardTitle: React.FC<CardTitleProps> = ({
  children,
  className = "",
}) => {
  return (
    <h2
      className={cn(
        "text-lg font-semibold text-primary sm:text-xl md:text-xl lg:text-2xl lg:leading-8 xl:text-2xl xl:leading-8",
        className
      )}
    >
      {children}
    </h2>
  );
};

interface CardDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

export const CardDescription: React.FC<CardDescriptionProps> = ({
  children,
  className = "",
}) => {
  return (
    <p
      className={cn(
        "text-xs text-muted-foreground sm:text-sm md:text-sm lg:text-sm xl:text-base xl:leading-5",
        className
      )}
    >
      {children}
    </p>
  );
};

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export const CardContent: React.FC<CardContentProps> = ({
  children,
  className = "",
}) => {
  return <div className={cn("mt-1 sm:mt-2", className)}>{children}</div>;
};
